import httpService from "../_utils/http-service";
import { getHttpConfig } from "../_utils/auth-utils";
import { traceEvent } from "../_utils/analytics-utils";

export const getRestaurantData = (restaurantId, callback) => {
  return function(dispatch) {
    traceEvent("restaurant", "get data");
    const url = `/v2/restaurants/${restaurantId}?serviceTypeId=1`;
    httpService.get(url, getHttpConfig()).then(res => {
      const restaurant = res.data.data;
      callback(restaurant);
    });
  };
};

export const fetchDish = ({ dishId, restaurantId }, callback) => {
  return function(dispatch) {
    const url = `/restaurants/${restaurantId}/dishes/${dishId}`;
    httpService.get(url, getHttpConfig()).then(res => {
      const dish = res.data.data;
      callback(dish);
    });
  };
};
